// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import global from '@/components/global.vue';
import VueI18n from 'vue-i18n';
// import 'lib-flexible'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n);

Vue.prototype.global = global;

Vue.prototype.global.ip = returnCitySN["cip"];


const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('@/common/lang/zh'), // 中文语言包
    'en-US': require('@/common/lang/en') // 英文语言包
  }
})


//点赞
var star = false;
Vue.prototype.beginStar = function() {
  var that = this;
  $('.star_content img').on('click', function(e) {
    e.preventDefault();
    if (!star) {
      star = true;
      setTimeout(function() {
        star = false;
      }, 2000)
      var data = {
        //ip
        ipKey: that.global.ip,
        //成员
        men: that.$route.path,
        //唯一key
        staus: "1",
      }
      axios.post(that.global.httpUrl + "star/beginStarAndViewCount", data).then(res => {
        var data = res.data;
        if (data) {

          if (data.code == 300) {
            if (that.$i18n.locale == 'zh-CN')
              message(that, "今天已经点过赞了,请明天再来~")
            else
              message(that, "I already like it today, please come back tomorrow~")
          } else if (data.code == 200) {

            if (that.$i18n.locale == 'zh-CN')
              message(that, "点赞成功~")
            else {
              message(that, "Like success~")
            }

            that.getViewAndStarCount();
          } else {
            if (that.$i18n.locale == 'zh-CN')
              message(that, "出现异常,请稍后再试~");
            else {
              message(that, "An exception occurred, please try again later~");
            }
          }
        }
      }).catch(error => {
        if (that.$i18n.locale == 'zh-CN')
          message(that, "出现异常,请稍后再试~");
        else {
          message(that, "An exception occurred, please try again later~");
        }
        // that.$message({
        //   message: "出现异常,请稍后再试~",
        //   duration: 1000,
        //   offset: 100
        // });

        console.log(error)
      })
    }
  })
}

function message(vue, content) {
  vue.$message({
    message: content,
    duration: 1000,
    offset: 100
  });
}

//增加浏览量
Vue.prototype.beginAddViewCount = function() {
  var that = this;
  var data = {
    //ip
    ipKey: that.global.ip,
    //成员
    men: that.$route.path,
    //唯一key
    staus: "2",
  }
  axios.post(that.global.httpUrl + "star/beginStarAndViewCount", data).then(res => {
    var data = res.data;
    if (data) {
      if (data.code == 300) {
        // console.log("重复浏览")
      } else if (data.code == 200) {
        that.getViewAndStarCount();
        // console.log("增加浏览次数")
      } else {
        // console.log("出现异常")
      }
    }
  }).catch(error => {
    console.log(error)
  })
}

//获取点赞和浏览数
Vue.prototype.getViewAndStarCount = function() {
  var that = this;
  var data = {
    //成员
    men: that.$route.path
  }
  axios.post(that.global.httpUrl + "star/getCount", data).then(res => {
    var data = res.data;
    if (data) {
      $('.star_content span').text(data.star);
      $('.view_content span').text(data.view);
    } else {
      $('.star_content span').text(0);
      $('.view_content span').text(0);
    }
  }).catch(error => {
    console.log(error)
  })
}

Vue.prototype.initAnimation = function(vue) {


  // vue.$nextTick(() => {

  var count = 10;
  var img_start = 0;
  if (document.readyState === 'complete') {
    console.log($("img").length)
    img_start++;

    // if (img_start > count) {
    var element = $('.animationEle');
    var moreElement = $('.animationMoreEle');
    var winheight = $(window).height();


    console.log("w+ " + winheight)
    for (var i = 0; i < element.length; i++) {
      var top = element.eq(i).offset().top;

      if (winheight > top) {
        console.log(top)

        $(".animationEle").eq(i).addClass("animationClass");
      }
    }
    for (var i = 0; i < moreElement.length; i++) {
      var top = moreElement.eq(i).offset().top;
      if (winheight > top) {
        if (i % 3 == 0) {
          $(".animationMoreEle").eq(i).addClass("animation-XClass");
        } else if (i % 3 == 1) {
          $(".animationMoreEle").eq(i).addClass("animationClass");
        } else {
          $(".animationMoreEle").eq(i).addClass("animationXClass");
        }
      }
    }
  }
  // }
  // });
}

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})




//切换路由时,将滑轮移至最上方
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});



// WEBPACK FOOTER //
// ./src/main.js